export default __webpack_public_path__ + "static/media/srovnejsito.d7d25948.png";